import PropTypes from 'prop-types'

import TitleOnly from './TitleOnly'
import TitleWithBankAccountDetailsLink from './TitleWithBankAccountDetailsLink'

const Title = ({payInvoice, onOpenBankAccountDetails}) => {
  if (payInvoice) {
    return (
      <TitleWithBankAccountDetailsLink
        onOpenBankAccountDetails={onOpenBankAccountDetails}
      />
    )
  }

  return <TitleOnly />
}

Title.propTypes = {
  payInvoice: PropTypes.bool.isRequired,
  onOpenBankAccountDetails: PropTypes.func.isRequired,
}

export default Title
